import general from './general';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [general]
};

export default menuItems;
